import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/membershipLengthSagas";
import MultiSelectDropdown from "../../../../../components/multiSelectDropdown/multiSelectDropdown";

const Type = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.membershipLengthByAgreement.filters.types);
  const selectedFilters = useSelector(
    (state) => state.membershipLengthByAgreement.selectedFilters.type
  );

  return options?.length ? (
    <div className="select-box" style={{ maxWidth: "170px" }}>
      <p>Type</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedFilters}
        includeFilter={false}
        numberDisplayed={1}
        width={300}
        onSelectChange={(data) => dispatch(actionCreators.updateFilters({ type: data }))}
      />
    </div>
  ) : null;
};

export default Type;
